import { z } from 'zod';
import { DriverSchema } from '../driver';

export const orderDriverSchema = DriverSchema.model.pick({
  _id: true,
  legal: true,
  userId: true,
  name: true,
  org: true,
  /** A client's driver: the CRM client he belongs to — `Order.carrier` is derived from it. */
  client: true,
  phone: true,
  type: true,
});
export type OrderDriver = z.infer<typeof orderDriverSchema>;
